import * as React from "react";
import { useContext, useMemo } from "react";
import FieldType from "views/logic/fieldtypes/FieldType";
import Action from "views/components/actions/Action";
import { ActionContext } from "views/logic/ActionContext";
const ValueActions = ({
  children,
  element,
  field,
  menuContainer = document.body,
  queryId,
  type = FieldType.Unknown,
  value
}) => {
  const actionContext = useContext(ActionContext);
  const handlerArgs = useMemo(
    () => ({ queryId, field, type, value, contexts: actionContext }),
    [actionContext, field, queryId, type, value]
  );
  const elementWithStatus = () => element;
  return /* @__PURE__ */ React.createElement(Action, { element: elementWithStatus, handlerArgs, menuContainer, type: "value" }, children);
};
export default ValueActions;
